import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes } from 'vue'
import type marquee from './marquee.vue'

export const marqueeProps = buildProps({
  vertical: {
    type: Boolean,
    default: false,
  },
  direction: {
    type: String as () => 'normal' | 'reverse',
    default: 'normal',
  },
  duration: {
    type: Number,
    default: 20,
  },
  delay: {
    type: Number,
    default: 0,
  },
  loop: {
    type: Number,
    default: 0,
  },
  clone: {
    type: Boolean,
    default: false,
  },
  animateOnOverflowOnly: {
    type: Boolean,
    default: false,
  },
  gradient: {
    type: Boolean,
    default: false,
  },
  gradientColor: {
    type: [String, Array],
    default: [255, 255, 255],
  },
  gradientWidth: {
    type: String,
    default: '',
  },
  gradientLength: {
    type: String,
    default: '',
  },
  pauseOnHover: {
    type: Boolean,
    default: false,
  },
  pauseOnClick: {
    type: Boolean,
    default: false,
  },
  pause: {
    type: Boolean,
    default: false,
  },
  height: {
    type: Number,
    default: 50,
  },
} as const)
export type MarqueeProps = ExtractPropTypes<typeof marqueeProps>
export type MarqueeInstance = InstanceType<typeof marquee>
